export default "__VITE_ASSET__CyyNT8y___"